<template>
  <g-page-wrapper>
    <template slot="pageTitle">
      <g-page-title >
        <template #title>
          <span class="-font-weight-bold">{{ $t('pages_contract_ContractDetail.contractinfo') }}</span>

        </template>
      </g-page-title>
    </template>
    <g-contents>
      <div class="-tile-container -py-5">
        <div class="-tile-container -wrapper fitting- nowrap-">
          <contract-info-cost-last-month />
          <div class="-tile-container">
            <contract-info-cost-trend-month />
          </div>
        </div>
        <div class="-tile-container -mt-5">
          <contract-info-cost-by-invoice />
        </div>
      </div>
    </g-contents>
  </g-page-wrapper>
</template>

<script>
import ContractInfoCostLastMonth from './components/ContractInfoCostLastMonth'
import ContractInfoCostTrendMonth from './components/ContractInfoCostTrendMonth'
import ContractInfoCostByInvoice from './components/ContractInfoCostByInvoice'
import {mapGetters} from "vuex";

export default {

  data() {
    return {
      paths: [{
        path: '/home',
        name: this.$t('pages_contract_ContractInfo.contractinfo')
      }
      ],

    }

  },
  computed: {
    ...mapGetters('user', ['userInfo'])
  },
  beforeMount() {
    // this.userInfo.companyCode
  },
  components: {
    ContractInfoCostLastMonth,
    ContractInfoCostTrendMonth,
    ContractInfoCostByInvoice
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/contract/ContractInfo.vue